import { TExchange, TMarket, TPair, getHeaders, withRetry } from "@root/common";
import { API_BASE_URL } from "../const";
import { IExchange, TChain, TCoin, TType } from "../types";


export async function getChains(): Promise<TChain[]> {
    try {
        const response = await withRetry(async () => await fetch(`${API_BASE_URL}/chains`, {
            headers: await getHeaders(),
        }))

        const json = await response.json()
        return json.chains
    } catch (err) {
        return [];
    }
}

export async function getCoins(type: TType[], chains: string[]): Promise<TCoin[]> {
    try {
        const query = new URLSearchParams(`type=${transformType(type)}&chains=${transformChains(chains)}`)
        const response = await withRetry(async () => await fetch(`${API_BASE_URL}/coin-contract-list?${query}`, {
            headers: await getHeaders(),
        }))

        const json = await response.json()
        return json
    } catch (err) {
        return [];
    }
}

export async function getExchanges(type: TType[], chain: string, coin: string): Promise<IExchange[]> {
    try {
        const query = new URLSearchParams(`type=${transformType(type)}&chain=${chain}&coin=${coin}`)
        const response = await withRetry(async () => await fetch(`${API_BASE_URL}/exchanges-list?${query}`, {
            headers: await getHeaders(),
        }))

        const json = await response.json()
        return json
    } catch (err) {
        return [];
    }
}

function transformType(type: TType[]) {
  return type.length === 2 ? 'all' : type[0]
}

function transformChains(chains: string[]) {
  return chains.join(',')
}
